import React , {Component} from 'react';
import { connect } from "react-redux";
import backIcon from './../assets/images/icons/back-2.svg';
import mapIcon from './../assets/images/icons/map.svg';
import motorbikeIcon from './../assets/images/icons/motorbike.svg';
import bankCardIcon from './../assets/images/icons/bank-card.svg';
import descriptionIcon from './../assets/images/icons/description.svg';
import shoppingBagIcon from './../assets/images/icons/shopping-bag-2.svg';
import forwardIcon from './../assets/images/icons/forward.svg';
import * as axios from "axios/index";
import * as vars from './Vars';
import {Link} from "react-router-dom";
import NumberFormat from 'react-number-format';
import { Modal } from 'react-bootstrap';

class InvoiceV4 extends Component{

    constructor(props){

        super(props)
        this.state = {
            branchSlug : "",
            inPageLoading : false ,

            deliveryPrice : 0 ,
            totalPayablePrice : 0 ,
            totalDiscountPrice : 0 ,

            submitError : false ,
            submitErrorMessage : '' ,

            removedProduct : [] ,
            removedProductModalShow : false ,

            updatedProductsQtyModalShow : false ,
            updatedProductsQty : [] ,
        }
    }

    componentDidMount(){
        const products = []
        /*this.props.cart.map((object , index) => {
            products.push({
                code : this.props.products[index].code ,
                qty : object
            })
        })*/
        Object.keys(this.props.cart).forEach(productId => {
            const qty = this.props.cart[productId];
            const product = this.props.products[productId];

            products.push({
                code: product.code,
                qty: qty
            });
        });
        let data = new FormData()
        data.append('api_token' , localStorage.getItem('api_token') )
        data.append('products' , JSON.stringify(products) )
        data.append('address' , localStorage.getItem('selectedAddress') )
        data.append('delivery_type' , localStorage.getItem('NORMAL') )
        data.append('use_wallet' , localStorage.getItem('use_wallet') )
        data.append('discount_code' , localStorage.getItem('discount_code'))
        data.append('delivery_time' , localStorage.getItem('orderDeliveryTimeKey'))
        data.append('delivery_date' , localStorage.getItem('orderDeliveryDateValue'))

        let branchSlug = localStorage.getItem("branchSlug")
        this.setState({
            branchSlug : branchSlug
        })
        axios.post(vars.Url +'api/v4/order/check/' + branchSlug , data , {
            params : {
            }

        } )
            .then(response => {
                let data = response.data.data
                // console.log(data)
                if (data.cart.removedProducts !== undefined  && data.cart.removedProducts.length > 0)
                {
                    this.setState({
                        removedProduct : data.cart.removedProducts ,
                        removedProductModalShow : true ,
                    })
                    data.cart.removedProducts.map((object,index) => {
                        delete this.props.cart[object.id];
                    })
                }

                if (data.cart.updatedProductsQty !== undefined  && data.cart.updatedProductsQty.length > 0)
                {
                    this.setState({
                        updatedProductsQty : data.cart.updatedProductsQty ,
                        updatedProductsQtyModalShow : true ,
                    })
                    data.cart.updatedProductsQty.map((object,index) => {
                        //console.log(object.qty)
                        this.props.cart[object.id] = object.qty
                        this.props.products[object.id] = {
                            ...this.props.products[object.id],
                            daily_stock_count: object.daily_stock_count
                        }
                    })
                }

                this.setState({
                    totalPayablePrice : data.cart.totalPayablePrice ,
                    totalDiscountPrice : data.cart.totalDiscountPrice ,
                    deliveryPrice : data.cart.deliveryPriceWithDiscount === null ?  data.cart.deliveryPrice : data.cart.deliveryPriceWithDiscount
                })
                localStorage.setItem("totalPayablePrice" , data.cart.totalPayablePrice)
                localStorage.setItem("deliveryPrice" , data.cart.deliveryPriceWithDiscount === null ?  data.cart.deliveryPrice : data.cart.deliveryPriceWithDiscount)
            })
            .catch(error => {
                // console.log(error)
                //let data = error.response.data.data
                // console.log(data)

            })
    }

    orderSubmit()
    {
        this.setState({
            inPageLoading : true
        })



        const products = []
        /*this.props.cart.map((object , index) => {
            products.push({
                code : this.props.products[index].code ,
                qty : object
            })
        })*/
        Object.keys(this.props.cart).forEach(productId => {
            const qty = this.props.cart[productId];
            const product = this.props.products[productId];

            products.push({
                code: product.code,
                qty: qty
            });
        });
        let data = new FormData()
        data.append('api_token' , localStorage.getItem('api_token') )
        data.append('products' , JSON.stringify(products) )
        data.append('address' , localStorage.getItem('selectedAddress') )
        data.append('delivery_type' , "NORMAL" )
        data.append('use_wallet' , localStorage.getItem('use_wallet') )
        data.append('description' , localStorage.getItem('description') )
        data.append('pay_type' , localStorage.getItem('pay_type'))
        data.append('delivery_time' , localStorage.getItem('orderDeliveryTimeKey'))
        data.append('order_delivery_time_selected_by_user' , localStorage.getItem('orderDeliveryTimeSelectedByUser') == 'true' ? 1 : 0)
        data.append('delivery_date' , localStorage.getItem('orderDeliveryDateValue'))
        data.append('discount_code' , localStorage.getItem('discount_code'))
        data.append('order_from' , "webapp")

        axios.post(vars.Url +'api/v4/order/store/' + this.state.branchSlug , data , {
            params : {
            }

        } )
            .then(response => {
                let data = response.data.data
                // console.log(data)

                // targetUrl

                /*this.setState({
                    inPageLoading : false
                })*/

                /*localStorage.removeItem("orderDeliveryDateTitle")
                localStorage.removeItem("orderDeliveryDateValue")
                localStorage.removeItem( "orderDeliveryDateIsToday")

                localStorage.removeItem( "orderDeliveryTimeTime")
                localStorage.removeItem( "orderDeliveryTimeTitle")
                localStorage.removeItem( "orderDeliveryTimeKey")
                localStorage.setItem( "orderDeliveryTimeSelectedByUser" , false)
                localStorage.removeItem("description")*/

                if (localStorage.getItem('pay_type') === "ONLINE")
                {
                    window.location.replace(data.targetUrl)
                }
                else
                {
                    window.location.replace(`/order/${data.order.orderNumber}`)
                }



            })
            .catch(error => {
                // console.log(error)
                let data = error.response.data.data
                console.log(data.message)
                this.setState({
                    inPageLoading : false ,
                    submitError : true ,
                    submitErrorMessage : data.message
                })
            })


    }

    submitErrorHandler(){
        this.setState({
            submitError : false ,
            submitErrorMessage : ''
        })
    }


    removedProductModalShowHandler(){
        this.setState({
            removedProductModalShow : false ,
            submitErrorMessage : ''
        })
    }


    updatedProductsQtyModalShowHandler(){
        this.setState({
            updatedProductsQtyModalShow : false ,
            submitErrorMessage : ''
        })
    }

    render(){
        return(
            <div id="main-custom-1" className="text-decoration-none">

                <Modal
                    show={this.state.removedProductModalShow}
                    onHide={this.removedProductModalShowHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>
                    <Modal.Header>
                        متاسفانه محصولات زیر به دلیل ناموجود شدن، از سبد خرید شما حذف شد
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mt-3">
                            {this.state.removedProduct.map((object , index) =>
                                <div
                                    key={index} className="content-custom-1 border-bottom pb-3 mb-3">
                                    {object.title}
                                </div>
                            )}

                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.removedProductModalShowHandler.bind(this)}>
                                خب
                            </button>
                        </div>



                    </Modal.Body>
                </Modal>


                <Modal
                    show={this.state.updatedProductsQtyModalShow}
                    onHide={this.updatedProductsQtyModalShowHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>
                    <Modal.Header>
                        تعداد محصولات زیر در سبد شما تغییر کرد
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mt-3">
                            {this.state.updatedProductsQty.map((object , index) =>
                                <div
                                    key={index} className="content-custom-1 border-bottom pb-3 mb-3">
                                    {object.title}
                                    حداکثر تعداد قابل خرید:
                                    {object.daily_stock_count}
                                    عدد
                                </div>
                            )}

                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.updatedProductsQtyModalShowHandler.bind(this)}>
                                خب
                            </button>
                        </div>



                    </Modal.Body>
                </Modal>



                <Modal
                    show={this.state.submitError}
                    onHide={this.submitErrorHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>

                    <Modal.Body>
                        <div className="mt-3">
                            <div className="content-custom-1 alert alert-danger">
                                {this.state.submitErrorMessage}
                            </div>
                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.submitErrorHandler.bind(this)}>
                                خب
                            </button>
                        </div>



                    </Modal.Body>
                </Modal>

                <div id="in-page-loading" className={(this.state.inPageLoading === true ? "show" : "")}>
                    <div className="content-container">
                        <div className="text-center mb-3">
                            <i className="fas fa-circle-notch fa-spin item-icon"/>
                        </div>
                        <div className="title">
                            لطفا شکیبا باشید
                        </div>
                    </div>
                </div>
                <header id="header-3">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">
                                <div className="items-container">
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <Link to="/payment">
                                                <span>
                                                    <img src={backIcon} alt="back" className="item-icon" />
                                                </span>
                                            </Link>

                                            <span className="title">
                                                فاکتور نهایی
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>


                <div className="container p-0 mt-5">
                    <div className="row no-gutters justify-content-center">
                        <div className="col-lg-6">
                            <div className="items-container items-container-custom-1 has-fixed-footer-1">

                                <div className="details-custom-1 mb-5">
                                    <div className="row no-gutters">
                                        <div className="col-auto pl-3">
                                            <img src={mapIcon} alt="map" className="item-icon"/>
                                        </div>
                                        <div className="col">
                                            <div className="title">
                                                ارسال به
                                                <span className="sub-title">
                                                    «
                                                    { localStorage.getItem("selectedAddressTitle") }
                                                    »
                                                </span>
                                            </div>
                                            <div className="value">
                                                { localStorage.getItem("selectedAddressBody") }
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div className="details-custom-1 mb-5">
                                    <div className="row no-gutters">
                                        <div className="col-auto pl-3">
                                            <img src={motorbikeIcon} alt="motorbike" className="item-icon"/>
                                        </div>
                                        <div className="col">
                                            <div className="title">
                                                شیوه تحویل
                                            </div>
                                            <div className="value">

                                                <div className="direction-ltr d-inline-block">
                                                    { localStorage.getItem("orderDeliveryDateTitle") }
                                                </div>

                                                <div className="mr-2 d-inline-block">
                                                    {
                                                        localStorage.getItem("orderDeliveryTimeSelectedByUser") == 'false' ?
                                                            (
                                                                `پس از آماده سازی`
                                                            )
                                                            :
                                                            (
                                                                localStorage.getItem("orderDeliveryTimeTitle")
                                                            )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div className="details-custom-1 mb-5">
                                    <div className="row no-gutters">
                                        <div className="col-auto pl-3">
                                            <img src={bankCardIcon} alt="bank" className="item-icon"/>
                                        </div>
                                        <div className="col">
                                            <div className="title">
                                                شیوه پرداخت
                                                <span className="sub-title">
                                                    «
                                                    { localStorage.getItem("pay_type") === "ONLINE" ?  "آنلاین"  : "نقدی در محل"}
                                                    »
                                                </span>
                                            </div>
                                            <div className="value">

                                                { localStorage.getItem("pay_type") === "ONLINE" ?  "با تمامی کارتهای عضو شتاب"  : "نقدی در محل"}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="details-custom-1 mb-5">
                                    <div className="row no-gutters">
                                        <div className="col-auto pl-3">
                                            <img src={descriptionIcon} alt="description" className="item-icon"/>
                                        </div>
                                        <div className="col">
                                            <div className="title">
                                                توضیح سفارش
                                            </div>
                                            <div className="value">
                                                { localStorage.getItem("description") }
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div className="details-custom-1 mb-5">
                                    <div className="row no-gutters">
                                        <div className="col-auto pl-3">
                                            <img src={shoppingBagIcon} alt="shopping bag" className="item-icon"/>
                                        </div>
                                        <div className="col">
                                            <div className="title">
                                                کالاهای انتخابی
                                            </div>
                                            <div className="value">
                                                {/*{this.props.cart.map((object , index) =>
                                                    <div className="row no-gutters mb-2" key={index}>
                                                        <div className="col-auto pl-3">
                                                            { this.props.products[index].title }
                                                            <span className="mr-2">
                                                                (
                                                                {object}
                                                                )
                                                            </span>
                                                        </div>
                                                        <div className="col">
                                                            <NumberFormat value={ object * this.props.products[index].price } displayType={'text'} thousandSeparator={true} className="pl-2" />
                                                            تومان
                                                        </div>
                                                    </div>
                                                )}*/}
                                                {Object.keys(this.props.cart).map(productId => {
                                                    const qty = this.props.cart[productId];
                                                    const product = this.props.products[productId];

                                                    return (
                                                        <div className="row no-gutters mb-2" key={productId}>
                                                            <div className="col-auto pl-3">
                                                                {product.title}
                                                                <span className="mr-2">
                                                                    ({qty})
                                                                </span>
                                                            </div>
                                                            <div className="col">
                                                                <NumberFormat
                                                                    value={qty * product.price}
                                                                    displayType={'text'}
                                                                    thousandSeparator={true}
                                                                    className="pl-2"
                                                                />
                                                                تومان
                                                            </div>
                                                        </div>
                                                    );
                                                })}

                                            </div>
                                        </div>
                                    </div>
                                </div>




                            </div>
                        </div>
                    </div>
                </div>




                <footer id="footer-2" className="text-decoration-none">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">
                                <div className="items-container">
                                    <div className="row justify-content-between align-items-center">
                                        <div className="col-auto">
                                            <div className="price">
                                                <div className="title">
                                                    جمع کل
                                                </div>
                                                <div className="value">
                                                    <NumberFormat value={this.state.totalPayablePrice} displayType={'text'} thousandSeparator={true}  />
                                                    <span className="currency">
                                                        تومان
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-auto">

                                            <div className="row">
                                                <div className="col-auto">
                                                    <div className="delivery-title">
                                                        پیک
                                                    </div>
                                                    <div className="discount-title">
                                                        جمع تخفیف
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="delivery-value">
                                                        {
                                                            this.state.deliveryPrice === 0 ?
                                                                ( `رایگان`)
                                                                :
                                                                (
                                                                    this.state.deliveryPrice + " تومان "
                                                                )
                                                        }
                                                    </div>
                                                    <div className="discount-value">
                                                        <NumberFormat value={this.state.totalDiscountPrice} displayType={'text'} thousandSeparator={true} className="pl-1" />
                                                        تومان
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="row mt-5">
                                        <div className="col">
                                            <div className="btn btn-custom-5 btn-block" onClick={this.orderSubmit.bind(this)}>
                                                ثبت سفارش
                                                <img src={forwardIcon} alt="back" className="item-icon" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>


            </div>
        )
    }
}


const mapDispatchToProps = dispatch => ({

})

const mapStateToProps = state => {
    return {
        cart : state.cart ,
        products : state.products ,
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(InvoiceV4);